export const ResetIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.86516 3.24852C7.15801 2.95558 7.15794 2.48071 6.86501 2.18786C6.57207 1.895 6.0972 1.89507 5.80435 2.18801L2.74258 5.25063L2.2124 5.78096L2.74266 6.31122L5.80442 9.37298C6.09731 9.66587 6.57219 9.66587 6.86508 9.37298C7.15797 9.08009 7.15797 8.60521 6.86508 8.31232L5.08365 6.53089H11.273V6.53035C11.2778 6.53066 11.2827 6.53082 11.2876 6.53082C14.0491 6.53082 16.2876 8.76939 16.2876 11.5308C16.2876 14.2922 14.0491 16.5308 11.2876 16.5308C9.07925 16.5308 7.20526 15.0991 6.54322 13.1132C6.42726 12.7654 6.11787 12.5035 5.75121 12.5035C5.28196 12.5035 4.91964 12.923 5.05242 13.3731C5.84673 16.0657 8.3377 18.0308 11.2876 18.0308C14.8775 18.0308 17.7876 15.1207 17.7876 11.5308C17.7876 7.94096 14.8775 5.03082 11.2876 5.03082C11.2827 5.03082 11.2778 5.03098 11.273 5.03129V5.03089H5.08329L6.86516 3.24852Z"
        fill="currentColor"
      />
    </svg>
  )
}
